// extracted by mini-css-extract-plugin
export default {"icon":"styleIcon_icon__luqXK"};